export default function urlEncodeAddress(item, type) {
    if (type === "venue") {
        return encodeURI(
            `${item.venue}, ${item.venueStreet},${item.venueCity},${item.venueState} ${item.venueCountry}`
        );
    } else if (type === "hotel") {
        return encodeURI(
            `${item.hotel}, ${item.hotelStreet},${item.hotelCity},${item.hotelState} ${item.hotelCountry}`
        );
    }
}
